import { type Reply, type UploadedFile, createReplyData } from 'models';
import { useMutation } from 'query';
import { editComment } from '../../services';
import { useUpdateComment } from '../hooks/useUpdateComment';

export const useEditCommentMutation = () => {
  const updateComment = useUpdateComment();

  return useMutation<
    Reply,
    {
      attachments?: UploadedFile[];
      contentObjectId: string;
      htmlContent?: string;
      id: string;
      parentId: string;
      textContent?: string;
    }
  >({
    async mutationFn({ attachments, htmlContent, id, parentId, textContent }) {
      const response = await editComment({
        /* eslint-disable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
        content_object: {
          attachments: attachments?.map((attachment) => ({ id: attachment.id })),
          html_content: htmlContent,
          id,
          parent_id: parentId,
          text_content: textContent,
        },
        /* eslint-enable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
      });

      return createReplyData(response.data);
    },
    onSuccess(reply, { contentObjectId }) {
      updateComment({ contentObjectId, reply });
    },
  });
};
